import {Component, OnInit} from '@angular/core';
import {User} from '../../classes/user';
import {AuthService} from '../../services/auth';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    user = new User();
    signInFailed = false;
    showPassword = false;

    constructor(private authService: AuthService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.router.navigate(['/dashboard']);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    onSubmit() {
        this.authService.signIn(this.user);
    }
}
